import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../lib/supabase';
import SEO from '../components/SEO';

export const Login: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setLoading(true);
    const { error: err } = await supabase.auth.signInWithPassword({ email, password });
    setLoading(false);
    if (err) {
      setError(err.message);
      return;
    }
    try {
      await supabase.from('users').update({ last_login_at: new Date().toISOString() }).eq('email', email);
    } catch (_) {}
    navigate('/crm');
  }

  return (
    <div className="min-h-screen grid place-items-center p-6">
      <SEO title="Login" description="Accesso CRM" canonical="https://victorlazari.com/login" />
      <form onSubmit={onSubmit} className="w-full max-w-md p-8 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-lg">
        <h1 className="text-2xl font-semibold mb-4 text-gray-900 dark:text-gray-100 leading-tight">Login</h1>
        <div className="mb-3">
          <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1 font-medium">Email</label>
          <input className="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:ring-cyan-500 focus:border-cyan-500" type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </div>
        <div className="mb-4">
          <label className="block text-sm text-gray-700 dark:text-gray-300 mb-1 font-medium">Password</label>
          <input className="w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 text-gray-900 dark:text-gray-100 placeholder-gray-500 focus:ring-cyan-500 focus:border-cyan-500" type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </div>
        {error && <div className="text-sm text-red-600 mb-3">{error}</div>}
        <button type="submit" disabled={loading} className="w-full py-2 rounded-lg bg-cyan-500 text-white font-semibold disabled:opacity-60 hover:bg-cyan-600 transition-colors duration-300 shadow-md">{loading ? 'Accesso…' : 'Accedi'}</button>
      </form>
    </div>
  );
};

export default Login;



